import { Injectable } from '@angular/core';
import * as Moment from 'moment/moment';
import { EmailFilterTracker } from '../../email/models/email-filter-tracker';
import { EmailFilterArchiver } from '../../email/models/email-filter-archiver';

@Injectable({
  providedIn: 'root',
})
export class TrackerSearch {
  protected param: string = '';
  protected filter: EmailFilterTracker | EmailFilterArchiver | null = null;

  constructor() {
  }

  reset(filter: EmailFilterTracker | EmailFilterArchiver) {
    this.setFilter(filter);
    this.resetParam();
  }

  setFilter(filter: EmailFilterTracker | EmailFilterArchiver) {
    this.filter = filter;
  }

  setParam(param: string) {
    this.param = param;
  }

  resetParam() {
    this.setParam('');
  }

  getParam(): string {
    return this.param;
  }

  protected insertName(name: string) {
    if (this.param.length) {
      this.param += '|';
    }
    this.param += name;
  }

  protected insertParam(value: string, original = false) {
    this.param += ',' + (original ? value : value.toString().toLowerCase());
  }

  public validateFilter(name: string) {
    if (this.filter[name]) {
      this.insertName(name === 'maxPerPage' ? name : name.toLowerCase());
      this.insertParam(this.filter[name]);
    }
  }

  public addParam(name: string, value: string, original = false) {
    this.insertName(name);
    this.insertParam(value, original);
  }

  public filterConvertDate(
    date: Moment.Moment,
    complete: '00:00:00' | '23:59:59' = '23:59:59',
  ): string {
    const dt = date.toDate();
    if (complete === '00:00:00') {
      dt.setHours(0, 0, 0, 0);
    } else {
      dt.setHours(23, 59, 59, 999);
    }
    return Moment(dt).format();
  }
}
